import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface SpaceCardProps {
  params: Record<string, string | string[]>;
  url: string;
}

export const SpaceCard = ({ params, url }: SpaceCardProps) => {
  const SPACE_FIELDS = {
    name: { label: t("spaces.form.create.space_name"), type: "string" },
    space_type: {
      label: t("spaces.form.create.space_types.label"),
      type: "humanize",
    },
    course_type: {
      label: t("spaces.form.create.course_types.label"),
      type: "string",
    },
    access: {
      label: t("spaces.duplicate.form.space_access_label"),
      type: "humanize",
    },
    default_notification_setting: {
      label: t("spaces.form.notification_type"),
      type: "boolean",
    },
    default_in_app_notification_setting: {
      label: t("notification_settings.in_app_notification_setting"),
      type: "boolean",
    },
    default_mobile_notification_setting: {
      label: t("notification_settings.mobile_notification_setting"),
      type: "boolean",
    },
    auto_rsvp_invited_attendees: {
      label: t("spaces.form.event_auto_rsvp_enabled"),
      type: "boolean",
    },
    notification_type: {
      label: t("spaces.form.create.notification_types.label"),
      type: "string",
    },
  };

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.space_card_title")}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(SPACE_FIELDS).map(
          ([key, keyProps]) =>
            params[key] && (
              <li key={key} className="!pb-0">
                <Typography.BodySm color="text-dark">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(params[key], keyProps.type)}
                </Typography.BodySm>
              </li>
            ),
        )}
      </ul>
    </PreviewCardLayout>
  );
};
